import { SERVICE_OGP_IMAGE, SITE_URL } from '../constants'
import { organizationProvider } from '../organization'
import { ServiceOfferItem } from '../types'
import { buildBreadcrumbList } from './breadcrumb'

export interface ServiceSchemaInput {
  slug: string
  name: string
  description: string
  serviceType: string
  category: string
  offerCatalogName: string
  offers: ServiceOfferItem[]
  breadcrumbName: string
}

export const buildServiceSchema = (input: ServiceSchemaInput) => {
  const pageUrl = `${SITE_URL}/services/${input.slug}/`

  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Service',
        '@id': pageUrl,
        name: input.name,
        description: input.description,
        url: pageUrl,
        image: SERVICE_OGP_IMAGE,
        provider: organizationProvider,
        serviceType: input.serviceType,
        category: input.category,
        areaServed: {
          '@type': 'Country',
          name: 'Japan',
        },
        availableChannel: {
          '@type': 'ServiceChannel',
          serviceUrl: pageUrl,
          servicePhone: {
            '@type': 'ContactPoint',
            telephone: '+81-3-6419-7700',
            contactType: 'customer service',
            areaServed: 'JP',
            availableLanguage: ['Japanese', 'English'],
          },
        },
        hasOfferCatalog: {
          '@type': 'OfferCatalog',
          name: input.offerCatalogName,
          itemListElement: input.offers.map((offer) => ({
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: offer.name,
              description: offer.description,
            },
          })),
        },
      },
      buildBreadcrumbList(pageUrl, [
        { name: 'ホーム', item: `${SITE_URL}/` },
        { name: 'サービス一覧', item: `${SITE_URL}/services/` },
        { name: input.breadcrumbName, item: pageUrl },
      ]),
    ],
  }
}
